import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { historyApi } from './patientsClient';
import type { ClinicalHistoryPayload } from '@/types/patients';

export const PATIENT_HISTORY_KEY = ['patientHistory'] as const;

export function usePatientHistory(
  patientId: string | null | undefined,
  opts: { enabled?: boolean } = {},
) {
  const enabled = (opts.enabled ?? true) && !!patientId;
  return useQuery({
    queryKey: [...PATIENT_HISTORY_KEY, patientId],
    queryFn: () => historyApi.get(patientId as string),
    enabled,
    staleTime: 15_000,
  });
}

export function useUpsertHistory(patientId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: ClinicalHistoryPayload) => historyApi.upsert(patientId, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...PATIENT_HISTORY_KEY, patientId] });
    },
  });
}
